// extracted by mini-css-extract-plugin
export default {"homepage":"Homepage_homepage__3fE70","pagetitle":"Homepage_pagetitle__dwP3p","maintitle":"Homepage_maintitle__Q9dlu"};